<div class="spinner" *ngIf="spinner.isVisible | async">
  <div class="spinner__dot"></div>
  <div class="spinner__dot"></div>
  <div class="spinner__dot"></div>
</div>
